import { render, staticRenderFns } from "./author.vue?vue&type=template&id=adc593c4"
import script from "./author.vue?vue&type=script&lang=js"
export * from "./author.vue?vue&type=script&lang=js"
import style0 from "./author.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports